import { registerLocaleData } from '@angular/common';
import af from '@angular/common/locales/af';
import am from '@angular/common/locales/am';
import ar from '@angular/common/locales/ar';
import as from '@angular/common/locales/as';
import az from '@angular/common/locales/az';
// import ba from '@angular/common/locales/ba';
import bg from '@angular/common/locales/bg';
import bn from '@angular/common/locales/bn';
import bo from '@angular/common/locales/bo';
import bs from '@angular/common/locales/bs';
import ca from '@angular/common/locales/ca';
import cs from '@angular/common/locales/cs';
import cy from '@angular/common/locales/cy';
import da from '@angular/common/locales/da';
import de from '@angular/common/locales/de';
import dsb from '@angular/common/locales/dsb';
// import dv from '@angular/common/locales/dv';
import el from '@angular/common/locales/el';
import enGB from '@angular/common/locales/en-GB';
// import enUS from '@angular/common/locales/en-US';
import es from '@angular/common/locales/es';
import et from '@angular/common/locales/et';
import eu from '@angular/common/locales/eu';
import fa from '@angular/common/locales/fa';
import fi from '@angular/common/locales/fi';
import fil from '@angular/common/locales/fil';
// import fj from '@angular/common/locales/fj';
import fo from '@angular/common/locales/fo';
import fr from '@angular/common/locales/fr';
import frCA from '@angular/common/locales/fr-CA';
import ga from '@angular/common/locales/ga';
import gl from '@angular/common/locales/gl';
// import gom from '@angular/common/locales/gom';
import gu from '@angular/common/locales/gu';
import ha from '@angular/common/locales/ha';
import he from '@angular/common/locales/he';
import hi from '@angular/common/locales/hi';
import hr from '@angular/common/locales/hr';
import hsb from '@angular/common/locales/hsb';
// import ht from '@angular/common/locales/ht';
import hu from '@angular/common/locales/hu';
import hy from '@angular/common/locales/hy';
import id from '@angular/common/locales/id';
import ig from '@angular/common/locales/ig';
// import ikt from '@angular/common/locales/ikt';
import is from '@angular/common/locales/is';
import it from '@angular/common/locales/it';
// import iu from '@angular/common/locales/iu';
// import iuLatn from '@angular/common/locales/iu-Latn';
import ja from '@angular/common/locales/ja';
import ka from '@angular/common/locales/ka';
import kk from '@angular/common/locales/kk';
import km from '@angular/common/locales/km';
// import kmr from '@angular/common/locales/kmr';
import kn from '@angular/common/locales/kn';
import ko from '@angular/common/locales/ko';
import ku from '@angular/common/locales/ku';
import ky from '@angular/common/locales/ky';
import ln from '@angular/common/locales/ln';
import lo from '@angular/common/locales/lo';
import lt from '@angular/common/locales/lt';
// import lug from '@angular/common/locales/lug';
import lv from '@angular/common/locales/lv';
// import lzh from '@angular/common/locales/lzh';
import mai from '@angular/common/locales/mai';
import mg from '@angular/common/locales/mg';
import mi from '@angular/common/locales/mi';
import mk from '@angular/common/locales/mk';
import ml from '@angular/common/locales/ml';
// import mnCyrl from '@angular/common/locales/mn-Cyrl';
// import mnMong from '@angular/common/locales/mn-Mong';
import mr from '@angular/common/locales/mr';
import ms from '@angular/common/locales/ms';
import mt from '@angular/common/locales/mt';
// import mww from '@angular/common/locales/mww';
import my from '@angular/common/locales/my';
import nb from '@angular/common/locales/nb';
import ne from '@angular/common/locales/ne';
import nl from '@angular/common/locales/nl';
// import nso from '@angular/common/locales/nso';
// import nya from '@angular/common/locales/nya';
import or from '@angular/common/locales/or';
// import otq from '@angular/common/locales/otq';
import pa from '@angular/common/locales/pa';
import pl from '@angular/common/locales/pl';
// import prs from '@angular/common/locales/prs';
import ps from '@angular/common/locales/ps';
import pt from '@angular/common/locales/pt';
import ptPT from '@angular/common/locales/pt-PT';
import ro from '@angular/common/locales/ro';
import ru from '@angular/common/locales/ru';
// import run from '@angular/common/locales/run';
import rw from '@angular/common/locales/rw';
import sd from '@angular/common/locales/sd';
import si from '@angular/common/locales/si';
import sk from '@angular/common/locales/sk';
import sl from '@angular/common/locales/sl';
// import sm from '@angular/common/locales/sm';
import sn from '@angular/common/locales/sn';
import so from '@angular/common/locales/so';
import sq from '@angular/common/locales/sq';
import srCyrl from '@angular/common/locales/sr-Cyrl';
import srLatn from '@angular/common/locales/sr-Latn';
// import st from '@angular/common/locales/st';
import sv from '@angular/common/locales/sv';
import sw from '@angular/common/locales/sw';
import ta from '@angular/common/locales/ta';
import te from '@angular/common/locales/te';
import th from '@angular/common/locales/th';
import ti from '@angular/common/locales/ti';
import tk from '@angular/common/locales/tk';
// import tn from '@angular/common/locales/tn';
import to from '@angular/common/locales/to';
import tr from '@angular/common/locales/tr';
import tt from '@angular/common/locales/tt';
// import ty from '@angular/common/locales/ty';
import ug from '@angular/common/locales/ug';
import uk from '@angular/common/locales/uk';
import ur from '@angular/common/locales/ur';
import uz from '@angular/common/locales/uz';
import vi from '@angular/common/locales/vi';
import xh from '@angular/common/locales/xh';
import yo from '@angular/common/locales/yo';
// import yua from '@angular/common/locales/yua';
import yue from '@angular/common/locales/yue';
import zhHans from '@angular/common/locales/zh-Hans';
import zhHant from '@angular/common/locales/zh-Hant';
import zu from '@angular/common/locales/zu';

export const languages = [
  { value: 'af', text: 'Afrikaans' },
  { value: 'sq', text: 'Albanian' },
  { value: 'am', text: 'Amharic' },
  { value: 'ar', text: 'Arabic' },
  { value: 'hy', text: 'Armenian' },
  { value: 'as', text: 'Assamese' },
  { value: 'az', text: 'Azerbaijani' },
  { value: 'bn', text: 'Bangla' },
  { value: 'ba', text: 'Bashkir' },
  { value: 'eu', text: 'Basque' },
  { value: 'bs', text: 'Bosnian' },
  { value: 'bg', text: 'Bulgarian' },
  { value: 'yue', text: 'Cantonese (Traditional)' },
  { value: 'ca', text: 'Catalan' },
  { value: 'lzh', text: 'Chinese (Literary)' },
  { value: 'zh-Hans', text: 'Chinese Simplified' },
  { value: 'zh-Hant', text: 'Chinese Traditional' },
  { value: 'hr', text: 'Croatian' },
  { value: 'cs', text: 'Czech' },
  { value: 'da', text: 'Danish' },
  { value: 'prs', text: 'Dari' },
  { value: 'dv', text: 'Divehi' },
  { value: 'nl', text: 'Dutch' },
  { value: 'en-GB', text: 'English (United Kingdom)' },
  { value: 'en-US', text: 'English (United States)' },
  { value: 'et', text: 'Estonian' },
  { value: 'fo', text: 'Faroese' },
  { value: 'fj', text: 'Fijian' },
  { value: 'fil', text: 'Filipino' },
  { value: 'fi', text: 'Finnish' },
  { value: 'fr', text: 'French' },
  { value: 'fr-CA', text: 'French (Canada)' },
  { value: 'gl', text: 'Galician' },
  { value: 'lug', text: 'Ganda' },
  { value: 'ka', text: 'Georgian' },
  { value: 'de', text: 'German' },
  { value: 'el', text: 'Greek' },
  { value: 'gu', text: 'Gujarati' },
  { value: 'ht', text: 'Haitian Creole' },
  { value: 'ha', text: 'Hausa' },
  { value: 'he', text: 'Hebrew' },
  { value: 'hi', text: 'Hindi' },
  { value: 'mww', text: 'Hmong Daw' },
  { value: 'hu', text: 'Hungarian' },
  { value: 'is', text: 'Icelandic' },
  { value: 'ig', text: 'Igbo' },
  { value: 'id', text: 'Indonesian' },
  { value: 'ikt', text: 'Inuinnaqtun' },
  { value: 'iu', text: 'Inuktitut' },
  { value: 'iu-Latn', text: 'Inuktitut (Latin)' },
  { value: 'ga', text: 'Irish' },
  { value: 'it', text: 'Italian' },
  { value: 'ja', text: 'Japanese' },
  { value: 'kn', text: 'Kannada' },
  { value: 'kk', text: 'Kazakh' },
  { value: 'km', text: 'Khmer' },
  { value: 'rw', text: 'Kinyarwanda' },
  { value: 'gom', text: 'Konkani' },
  { value: 'ko', text: 'Korean' },
  { value: 'ku', text: 'Kurdish (Central)' },
  { value: 'kmr', text: 'Kurdish (Northern)' },
  { value: 'ky', text: 'Kyrgyz' },
  { value: 'lo', text: 'Lao' },
  { value: 'lv', text: 'Latvian' },
  { value: 'ln', text: 'Lingala' },
  { value: 'lt', text: 'Lithuanian' },
  { value: 'dsb', text: 'Lower Sorbian' },
  { value: 'mk', text: 'Macedonian' },
  { value: 'mai', text: 'Maithili' },
  { value: 'mg', text: 'Malagasy' },
  { value: 'ms', text: 'Malay' },
  { value: 'ml', text: 'Malayalam' },
  { value: 'mt', text: 'Maltese' },
  { value: 'mi', text: 'Māori' },
  { value: 'mr', text: 'Marathi' },
  { value: 'mn-Cyrl', text: 'Mongolian (Cyrillic)' },
  { value: 'mn-Mong', text: 'Mongolian (Traditional)' },
  { value: 'my', text: 'Myanmar (Burmese)' },
  { value: 'ne', text: 'Nepali' },
  { value: 'nb', text: 'Norwegian' },
  { value: 'nya', text: 'Nyanja' },
  { value: 'or', text: 'Odia' },
  { value: 'ps', text: 'Pashto' },
  { value: 'fa', text: 'Persian' },
  { value: 'pl', text: 'Polish' },
  { value: 'pt', text: 'Portuguese (Brazil)' },
  { value: 'pt-PT', text: 'Portuguese (Portugal)' },
  { value: 'pa', text: 'Punjabi' },
  { value: 'otq', text: 'Querétaro Otomi' },
  { value: 'ro', text: 'Romanian' },
  { value: 'run', text: 'Rundi' },
  { value: 'ru', text: 'Russian' },
  { value: 'sm', text: 'Samoan' },
  { value: 'sr-Cyrl', text: 'Serbian (Cyrillic)' },
  { value: 'sr-Latn', text: 'Serbian (Latin)' },
  { value: 'st', text: 'Sesotho' },
  { value: 'nso', text: 'Sesotho sa Leboa' },
  { value: 'tn', text: 'Setswana' },
  { value: 'sn', text: 'Shona' },
  { value: 'sd', text: 'Sindhi' },
  { value: 'si', text: 'Sinhala' },
  { value: 'sk', text: 'Slovak' },
  { value: 'sl', text: 'Slovenian' },
  { value: 'so', text: 'Somali' },
  { value: 'es', text: 'Spanish' },
  { value: 'sw', text: 'Swahili' },
  { value: 'sv', text: 'Swedish' },
  { value: 'ty', text: 'Tahitian' },
  { value: 'ta', text: 'Tamil' },
  { value: 'tt', text: 'Tatar' },
  { value: 'te', text: 'Telugu' },
  { value: 'th', text: 'Thai' },
  { value: 'bo', text: 'Tibetan' },
  { value: 'ti', text: 'Tigrinya' },
  { value: 'to', text: 'Tongan' },
  { value: 'tr', text: 'Turkish' },
  { value: 'tk', text: 'Turkmen' },
  { value: 'uk', text: 'Ukrainian' },
  { value: 'hsb', text: 'Upper Sorbian' },
  { value: 'ur', text: 'Urdu' },
  { value: 'ug', text: 'Uyghur' },
  { value: 'uz', text: 'Uzbek (Latin)' },
  { value: 'vi', text: 'Vietnamese' },
  { value: 'cy', text: 'Welsh' },
  { value: 'xh', text: 'Xhosa' },
  { value: 'yo', text: 'Yoruba' },
  { value: 'yua', text: 'Yucatec Maya' },
  { value: 'zu', text: 'Zulu' },
];

export function registerLocales() {
  registerLocaleData(af, 'af');
  registerLocaleData(am, 'am');
  registerLocaleData(ar, 'ar');
  registerLocaleData(as, 'as');
  registerLocaleData(az, 'az');
  registerLocaleData(enGB, 'ba'); // registerLocaleData(ba, 'ba');
  registerLocaleData(bg, 'bg');
  registerLocaleData(bn, 'bn');
  registerLocaleData(bo, 'bo');
  registerLocaleData(bs, 'bs');
  registerLocaleData(ca, 'ca');
  registerLocaleData(cs, 'cs');
  registerLocaleData(cy, 'cy');
  registerLocaleData(da, 'da');
  registerLocaleData(de, 'de');
  registerLocaleData(dsb, 'dsb');
  registerLocaleData(enGB, 'dv'); // registerLocaleData(dv, 'dv');
  registerLocaleData(el, 'el');
  registerLocaleData(enGB, 'en-GB');
  registerLocaleData(enGB, 'enUS'); // registerLocaleData(enUS, 'enUS');
  registerLocaleData(es, 'es');
  registerLocaleData(et, 'et');
  registerLocaleData(eu, 'eu');
  registerLocaleData(fa, 'fa');
  registerLocaleData(fi, 'fi');
  registerLocaleData(fil, 'fil');
  registerLocaleData(enGB, 'fj'); // registerLocaleData(fj, 'fj');
  registerLocaleData(fo, 'fo');
  registerLocaleData(fr, 'fr');
  registerLocaleData(frCA, 'fr-CA');
  registerLocaleData(ga, 'ga');
  registerLocaleData(gl, 'gl');
  registerLocaleData(enGB, 'gom'); // registerLocaleData(gom, 'gom');
  registerLocaleData(gu, 'gu');
  registerLocaleData(ha, 'ha');
  registerLocaleData(he, 'he');
  registerLocaleData(hi, 'hi');
  registerLocaleData(hr, 'hr');
  registerLocaleData(hsb, 'hsb');
  registerLocaleData(enGB, 'ht'); // registerLocaleData(ht, 'ht');
  registerLocaleData(hu, 'hu');
  registerLocaleData(hy, 'hy');
  registerLocaleData(id, 'id');
  registerLocaleData(ig, 'ig');
  registerLocaleData(enGB, 'ikt'); // registerLocaleData(ikt, 'ikt');
  registerLocaleData(is, 'is');
  registerLocaleData(it, 'it');
  registerLocaleData(enGB, 'iu'); // registerLocaleData(iu, 'iu');
  registerLocaleData(enGB, 'iuLatn'); // registerLocaleData(iuLatn, 'iuLatn');
  registerLocaleData(ja, 'ja');
  registerLocaleData(ka, 'ka');
  registerLocaleData(kk, 'kk');
  registerLocaleData(km, 'km');
  registerLocaleData(enGB, 'kmr'); // registerLocaleData(kmr, 'kmr');
  registerLocaleData(kn, 'kn');
  registerLocaleData(ko, 'ko');
  registerLocaleData(ku, 'ku');
  registerLocaleData(ky, 'ky');
  registerLocaleData(ln, 'ln');
  registerLocaleData(lo, 'lo');
  registerLocaleData(lt, 'lt');
  registerLocaleData(enGB, 'lug'); // registerLocaleData(lug, 'lug');
  registerLocaleData(lv, 'lv');
  registerLocaleData(enGB, 'lzh'); // registerLocaleData(lzh, 'lzh');
  registerLocaleData(mai, 'mai');
  registerLocaleData(mg, 'mg');
  registerLocaleData(mi, 'mi');
  registerLocaleData(mk, 'mk');
  registerLocaleData(ml, 'ml');
  registerLocaleData(enGB, 'mnCyrl'); // registerLocaleData(mnCyrl, 'mnCyrl');
  registerLocaleData(enGB, 'mnMong'); // registerLocaleData(mnMong, 'mnMong');
  registerLocaleData(mr, 'mr');
  registerLocaleData(ms, 'ms');
  registerLocaleData(mt, 'mt');
  registerLocaleData(enGB, 'mww'); // registerLocaleData(mww, 'mww');
  registerLocaleData(my, 'my');
  registerLocaleData(nb, 'nb');
  registerLocaleData(ne, 'ne');
  registerLocaleData(nl, 'nl');
  registerLocaleData(enGB, 'nso'); // registerLocaleData(nso, 'nso');
  registerLocaleData(enGB, 'nya'); // registerLocaleData(nya, 'nya');
  registerLocaleData(or, 'or');
  registerLocaleData(enGB, 'otq'); // registerLocaleData(otq, 'otq');
  registerLocaleData(pa, 'pa');
  registerLocaleData(pl, 'pl');
  registerLocaleData(enGB, 'prs'); // registerLocaleData(prs, 'prs');
  registerLocaleData(ps, 'ps');
  registerLocaleData(pt, 'pt');
  registerLocaleData(ptPT, 'pt-PT');
  registerLocaleData(ro, 'ro');
  registerLocaleData(ru, 'ru');
  registerLocaleData(enGB, 'run'); // registerLocaleData(run, 'run');
  registerLocaleData(rw, 'rw');
  registerLocaleData(sd, 'sd');
  registerLocaleData(si, 'si');
  registerLocaleData(sk, 'sk');
  registerLocaleData(sl, 'sl');
  registerLocaleData(enGB, 'sm'); // registerLocaleData(sm, 'sm');
  registerLocaleData(sn, 'sn');
  registerLocaleData(so, 'so');
  registerLocaleData(sq, 'sq');
  registerLocaleData(srCyrl, 'sr-Cyrl');
  registerLocaleData(srLatn, 'sr-Latn');
  registerLocaleData(enGB, 'st'); // registerLocaleData(st, 'st');
  registerLocaleData(sv, 'sv');
  registerLocaleData(sw, 'sw');
  registerLocaleData(ta, 'ta');
  registerLocaleData(te, 'te');
  registerLocaleData(th, 'th');
  registerLocaleData(ti, 'ti');
  registerLocaleData(tk, 'tk');
  registerLocaleData(enGB, 'tn'); // registerLocaleData(tn, 'tn');
  registerLocaleData(to, 'to');
  registerLocaleData(tr, 'tr');
  registerLocaleData(tt, 'tt');
  registerLocaleData(enGB, 'ty'); // registerLocaleData(ty, 'ty');
  registerLocaleData(ug, 'ug');
  registerLocaleData(uk, 'uk');
  registerLocaleData(ur, 'ur');
  registerLocaleData(uz, 'uz');
  registerLocaleData(vi, 'vi');
  registerLocaleData(xh, 'xh');
  registerLocaleData(yo, 'yo');
  registerLocaleData(enGB, 'yua'); // registerLocaleData(yua, 'yua');
  registerLocaleData(yue, 'yue');
  registerLocaleData(zhHans, 'zh-Hans');
  registerLocaleData(zhHant, 'zh-Hant');
  registerLocaleData(zu, 'zu');
}
